import React, { Component } from 'react'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import { Well, ButtonToolbar, Button } from '@sketchpixy/rubix'
import { selectBroadcasts } from '../../selectors/messagesSelector'
import InboxItem from '../common/InboxItem'
import { FETCH_BROADCASTS_REQUEST } from '../../actions/actions'
import QueryAble from '../common/SearchAndQueryBar'

class BroadcastedMessages extends Component {
  componentWillMount() {
    const {
      userType,
      dispatch,
      broadcastedMessages: { result: broadcastedMessages, isEverSynced },
    } = this.props

    const isManager = userType === 'MANAGER'

    if (!isManager) {
      browserHistory.push('/dashboard/messages/')
    }

    if (isManager && (broadcastedMessages.length === 0 || isEverSynced === false)) {
      dispatch({ type: FETCH_BROADCASTS_REQUEST })
    }
  }

  onBroadcastRequest = () => {
    browserHistory.push('/dashboard/messages/compose')
  }

  render() {
    const {
      broadcastedMessages: {
        entities: { broadcasts },
        result: broadcastedMessages,
        messagesCount,
      },
    } = this.props

    return (
      <div>
        <Well>
          <ButtonToolbar>
            <span>
              <span>پیام های دسته جمعی ارسال شده</span>
            </span>
          </ButtonToolbar>
        </Well>

        <QueryAble
          noQuery={true}
          itemsCount={messagesCount}
          collapsed={false}
          actionType={FETCH_BROADCASTS_REQUEST}
        >
          <div className="message-page">
            {broadcastedMessages.map((messageId, i) => (
              <InboxItem
                key={i}
                type="broadcasted"
                massageId={messageId}
                description={broadcasts[messageId].text}
                date={broadcasts[messageId].sent_at}
              />
            ))}
          </div>
        </QueryAble>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    userType: state.auth.userType,
    ...selectBroadcasts(state),
  }
}

export default connect(mapStateToProps)(BroadcastedMessages)



// WEBPACK FOOTER //
// ./src/components/manager/BroadcastedMessages.js